import { useEffect } from 'react';
import { Modal, Form, Input, Typography } from 'antd';
import endpoints from '../../api/endpoints';
import { notifyError, notifySuccess } from '../../utils/notify';

// Stage R1: simple modal that prompts for a recipient and POSTs to
// /api/reports/jobs/:id/email. The backend uses the existing notification
// service, which in R1 is in console-mode by default — operators see
// the email body in the backend log instead of an SMTP send. Producton
// SMTP wiring is documented as future R2 work.

export default function ReportEmailModal({ open, jobId, defaultRecipient, onClose }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
      if (defaultRecipient) {
        form.setFieldsValue({ recipient: defaultRecipient });
      }
    }
  }, [open, defaultRecipient, form]);

  async function handleOk() {
    let values;
    try {
      values = await form.validateFields();
    } catch (_e) {
      return;
    }
    try {
      await endpoints.reports.emailJob(jobId, { recipient: values.recipient.trim() });
      notifySuccess('Report email queued', `We will send the report to ${values.recipient.trim()}.`);
      onClose && onClose(true);
    } catch (err) {
      notifyError(err, 'Could not send the report email.');
    }
  }

  return (
    <Modal
      title="Email report"
      open={open}
      onCancel={() => onClose && onClose(false)}
      onOk={handleOk}
      okText="Send"
    >
      <Typography.Paragraph type="secondary" style={{ marginTop: 0 }}>
        We will send a notice to the recipient. (R1: console-mode email — production
        SMTP wiring is pending.)
      </Typography.Paragraph>
      <Form form={form} layout="vertical">
        <Form.Item
          label="Recipient email"
          name="recipient"
          rules={[
            { required: true, message: 'Please enter a recipient email' },
            { type: 'email', message: 'Please enter a valid email address' },
            { max: 320, message: 'Email is too long' }
          ]}
        >
          <Input placeholder="reports@company.example" autoComplete="email" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
